// Import and expose jQuery globally
import $ from 'jquery';
window.$ = window.jQuery = $;

// Import Slick Carousel
import 'slick-carousel';


$(document).ready(function () {


   $('.sliderteaser > .teasers').on('afterChange', function(event, slick, currentSlide){
         lazyLoadInstance.update();
    });

   $('.sliderteaser > .teasers').on('init', function(event, slick){
console.log("here");

         lazyLoadInstance.update();
    });

   $('.sliderthis').on('init', function(event, slick){
console.log("here");

         lazyLoadInstance.update();
    });


    $('.media-grid.layout-galleryslider').on('init', function(event, slick){
console.log("media-grid slick here");

         lazyLoadInstance.update();
    });

  $('.sliderteaser > .teasers').slick({
         centerMode: true,
          centerPadding: '12%',
          slidesToShow: 3,
          arrows: false,
          focusOnSelect: true,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 4000,
          responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 1,
                  }
                },
            ]
      });



  
  $('.teasers.layout-unternehmensgeschichte').slick({
          slidesToShow: 4,
          arrows: true,
          focusOnSelect: true,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
          prevArrow: '<button class="slick-prev" aria-label="Previous"> < Zurück</button>',
          nextArrow: '<button class="slick-next" aria-label="Next">Weiter ></button>',
          // autoplay: true,
          // autoplaySpeed: 4000,
          responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                  }
                },
            ]
      });

    $('.sliderthis').slick({
          slidesToShow: 5,
          centerMode: true,
          centerPadding: '0px',
          speed: 1000,
          arrows: false,
          dots: true,
          infinite: true,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 4000,
          responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 3,
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                  breakpoint: 500,
                  settings: {
                    slidesToShow: 1,
                  }
                }
            ]
    });




     $('#locations_container_slider > .posts').slick({
          slidesToShow: 2,
          arrows: true,
          focusOnSelect: true,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
          prevArrow: '<button class="slick-prev" aria-label="Previous"></button>',
          nextArrow: '<button class="slick-next" aria-label="Next"></button>',
          // autoplay: true,
          // autoplaySpeed: 4000,
          responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                  }
                },
            ]
      });


     $('.media-grid.layout-galleryslider').slick({
          slidesToShow: 1,
          arrows: true,
          focusOnSelect: true,
          speed: 1000,
          autoplay: false,
          autoplaySpeed: 4000,
          dots: false,
          infinite: true,
          slidesToScroll: 1,
          prevArrow: '<button class="slick-prev" aria-label="Previous"></button>',
          nextArrow: '<button class="slick-next" aria-label="Next"></button>',
      });


     var mobslider = jQuery('.events-slider-mobile .section-wrapper > .section-row').clone();
      mobslider.addClass('showonmobile events-slider-mobile-post');
      mobslider.find('.col.align-self-stretch').remove();
      var clonepost = jQuery('.events-slider-mobile .section-row div.post').clone();
      mobslider.find('.row.justify-content-between').append(clonepost);
      jQuery('.events-slider-mobile .section-wrapper > .section-row').addClass('hideonmobilerev');
      jQuery('.events-slider-mobile .section-wrapper').append(mobslider);
      lazyLoadInstance.update();

      requestAnimationFrame(() => {
        console.log("here");
        mobslider.find('.row.cols-row').slick({
            slidesToShow: 1,
            arrows: true,
            focusOnSelect: true,
            speed: 1000,
            autoplay: false,
            autoplaySpeed: 4000,
            dots: false,
            infinite: true,
            slidesToScroll: 1,
            prevArrow: '<button class="slick-prev" aria-label="Previous"></button>',
            nextArrow: '<button class="slick-next" aria-label="Next"></button>',
        });
      });

});